import { DROP_TYPE_PATH } from "@pathwright/web/src/modules/path/constants"
import classnames from "classnames"
import { DESIGN, PATH_MODE_LABELS } from "path/constants"
import PropTypes from "prop-types"
import React from "react"
import { Droppable } from "react-beautiful-dnd"
import DragDropPathItems, {
  DragDropPathItemsContext
} from "../DragDropPathItems"
import PathListAppend from "../manage/PathListAppend"
import PathListInsert from "../manage/PathListInsert"
import PathGroupContainer from "./group/PathGroupContainer"
// TODO: _scrollToGroup
import "./PathList.css"
import PathTopic from "./topic/PathTopic"
import PathTopicEditor from "./topic/PathTopicEditor"

const isValidItemType = function (item) {
  const validTypes = ["T", "G", "I", "N"]
  return Array.from(validTypes).includes(item.item_type)
}

const getPathListComponent = function (item, mode) {
  const isEditing = mode === DESIGN
  switch (item.item_type) {
    case "T":
      if (isEditing) {
        return PathTopicEditor
      } else {
        return PathTopic
      }
    case "G":
      return PathGroupContainer
    case "I":
      return PathListInsert
    case "N":
      return PathListAppend
    default:
      return console.warn(
        `No Component found for item type ${item.item_type}`,
        item
      )
  }
}

var PathListItem = function (props) {
  const { item, mode, findItem, stepCount, lastOrder, index } = props

  const Component = getPathListComponent(item, mode)
  const passProps = { item, mode, index }

  if (["I", "N"].includes(item.item_type)) {
    passProps.order = lastOrder + 1
  }

  return <Component {...Object.assign({}, passProps)} />
}

PathListItem.displayName = "PathListItem"

class PathListItems extends React.Component {
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.isDragging) {
      return false
    }
    return true
  }

  render() {
    const { items, mode, filter } = this.props
    let lastOrder = 1

    return (
      <div>
        {items.filter(isValidItemType).map(function (item, index) {
          // Must update lastOrder now before early return to ensure stable lastOrder
          // whether or not item is filtered out.
          if (item.sync_source_id) {
            lastOrder = item.order
          }

          // allow for rendering a filtered set of items, yet retaining the correct index
          if (filter && !filter(item)) return null

          const key = item.sync_source_id
            ? `path-item-${item.sync_source_id}`
            : `path-item-index-${index}`

          return (
            <PathListItem
              key={key}
              index={index}
              item={item}
              mode={mode}
              lastOrder={lastOrder}
            />
          )
        })}
      </div>
    )
  }
}

PathListItems.displayName = "PathListItems"

const PathList = function ({ path, items }, { mode }) {
  const classNames = classnames(
    "PathList",
    `PathList--${PATH_MODE_LABELS[mode]}`
  )

  return mode === DESIGN ? (
    <DragDropPathItems
      // filter out any faux items
      items={items.filter((item) => !!item.id)}
    >
      <DragDropPathItemsContext.Consumer>
        {({ isDragging }) => (
          <Droppable droppableId={path.id + ""} type={DROP_TYPE_PATH}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                className={classnames(classNames, {
                  "PathList--dragging": isDragging
                })}
              >
                <PathListItems
                  items={items}
                  mode={mode}
                  isDragging={isDragging}
                  filter={(item) => item.item_type !== "N"} // filtering out append item
                />
                {provided.placeholder}
                {/* rendering append item here to avoid UI glitch when dragging */}
                <PathListItems
                  items={items}
                  mode={mode}
                  isDragging={isDragging}
                  filter={(item) => item.item_type === "N"} // only rendering append item
                />
              </div>
            )}
          </Droppable>
        )}
      </DragDropPathItemsContext.Consumer>
    </DragDropPathItems>
  ) : (
    <div className={classNames}>
      <PathListItems items={items} mode={mode} />
    </div>
  )
}

PathList.displayName = "PathList"
PathList.contextTypes = { mode: PropTypes.number }

export default PathList
